import { render, staticRenderFns } from "./ditch.vue?vue&type=template&id=592276a0&"
import script from "./ditch.vue?vue&type=script&lang=js&"
export * from "./ditch.vue?vue&type=script&lang=js&"
import style0 from "./ditch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports